import { useEffect } from 'react';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import SaveTheDateSection from './components/SaveTheDateSection';
import InfoBar from './components/InfoBar';
import LocationSection from './components/LocationSection';
import GiftSection from './components/GiftSection';
import GallerySection from './components/GallerySection';
import FooterSection from './components/FooterSection';

export default function Home() {
  useEffect(() => {
    const elements = document.querySelectorAll<HTMLElement>('main > section, footer');
    elements.forEach((element) => element.classList.add('site-reveal'));

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('site-reveal-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -45px' });

    elements.forEach((element) => observer.observe(element));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="min-h-screen bg-background-100">
      <Navbar />
      <main>
        <HeroSection />
        <SaveTheDateSection />
        <InfoBar />
        <LocationSection />
        <GiftSection />
        <GallerySection />
      </main>
      <FooterSection />
    </div>
  );
}
